

export default {
    install(Vue, store) {

        if (!store || !store.dispatch) {
            console.error('Vuex store não encontrado. Certifique-se de passar a instância do store corretamente.');
            return;
        }

        const checkStorageUser = () => {
            const data = getStorageUser();
            if(data){
                store.dispatch('setUserId', data.id);
                store.dispatch('setUserName', data.name);
                store.dispatch('setUserEmail', data.email);
                store.dispatch('setUserToken', data.token);
                store.dispatch('setUserIsAdmin', data.isAdmin);
                store.dispatch('setUserTeams', data.teams);
            }
        }

        const getStorageUser = () => {
            const jsonString = Vue.ls.get(process.env.VUE_APP_LOCAL_STORAGE_NAME);
            if (jsonString) {
                try {
                    const data = JSON.parse(jsonString);
                    return data && typeof data === 'object' ? data : null;
                } catch (e) {
                    return null;
                }
            }
        }

        const setLsUser = (user) => {
            let name = process.env.VUE_APP_LOCAL_STORAGE_NAME;
            Vue.ls.set(name, JSON.stringify({"id" : user.id, "name": user.name, "email" : user.email, "token" : user.token, "idAdmin" : user.role, 
                "teams": user.teams}));
        }

        const setStateUser = (user) => {
            store.dispatch('setUserId', user.id);
            store.dispatch('setUserName', user.name);
            store.dispatch('setUserEmail', user.email);
            store.dispatch('setUserToken', user.token);
            store.dispatch('setUserIsAdmin', user.role);
            store.dispatch('setUserTeams', user.teams);
        }

        Vue.prototype.$setDataUser = function (user) {
            setStateUser(user);
            setLsUser(user);
            return;
        };

        Vue.prototype.$setLsFrom = function (f) {
            if(f != '/login' && f != '/cadastre-se'){
                let name = process.env.VUE_APP_LOCAL_STORAGE_FROM;
                Vue.ls.set(name, f);
            }
            return;
        };

        Vue.prototype.$getDataUser = function (){
            let from = Vue.ls.get(process.env.VUE_APP_LOCAL_STORAGE_FROM);
            return (from != '' && from != '/' && from != '/login') ? from : process.env.VUE_APP_ROOT_INIT;
        }

        checkStorageUser();
    }
}